// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1903":"22f298fd","3057":"35311b3f","5352":"22f298fd","5766":"22f298fd"}[chunkId] + ".chunk.css";
};